/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ErrorModel,
    ErrorModelFromJSON,
    ErrorModelFromJSONTyped,
    ErrorModelToJSON,
} from './ErrorModel';

/**
 * 
 * @export
 * @interface BooleanValidatedModel
 */
export interface BooleanValidatedModel {
    /**
     * 
     * @type {ErrorModel}
     * @memberof BooleanValidatedModel
     */
    error?: ErrorModel;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanValidatedModel
     */
    readonly success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanValidatedModel
     */
    data?: boolean;
}

export function BooleanValidatedModelFromJSON(json: any): BooleanValidatedModel {
    return BooleanValidatedModelFromJSONTyped(json, false);
}

export function BooleanValidatedModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BooleanValidatedModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : ErrorModelFromJSON(json['error']),
        'success': !exists(json, 'success') ? undefined : json['success'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function BooleanValidatedModelToJSON(value?: BooleanValidatedModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ErrorModelToJSON(value.error),
        'data': value.data,
    };
}

